module.exports = __webpack_public_path__ + "static/img/full02.2bfe65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/full02.png
// module id = GDG8
// module chunks = 0